import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { ProductTypeService } from 'application/product-type/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { action } from 'mobx';

@applicationContext
class ProductTypeListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new ProductTypeService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'product-type',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.product-type.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.product-type.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({
                            ...params,
                            embed:'DefaultItemTypeTags,ItemCategory'
                        });

                        return response.data;
                    },
                    delete: async (item) => {
                        await service.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'PRODUCT_TYPE.LIST.COLUMNS.NAME'
                },
                {
                    key: 'category',
                    title: 'PRODUCT_TYPE.LIST.COLUMNS.CATEGORY',
                    sortable: true
                },
                {
                    key: 'tags',
                    title: 'PRODUCT_TYPE.LIST.COLUMNS.TAGS',
                    sortable: false
                },
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async (item) => this.deleteResource(item)
            }
        }));
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('PRODUCT_TYPE.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default ProductTypeListViewStore;
